import styled from 'styled-components'
import { get } from '@utils'

export const List = styled.ul`
  ${get('styles.list')};
`
